import { useLang } from "@/i18n";
import SearchBar from "@/components/SearchBar";

export default function Hero() {
  const { t, simg } = useLang();
  return (
    <section data-testid="hero" className="relative flex min-h-screen flex-col overflow-hidden">
      <img
        src={simg("hero")}
        alt="Terrasse de villa face à la mer en Corse-du-Sud"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-mer/55 via-mer/15 to-mer/60" />

      <div className="relative flex flex-1 flex-col items-center justify-end px-5 sm:px-8 pt-32 pb-[14vh] text-center text-casse">
        <div className="w-full max-w-5xl">
          <p data-testid="hero-eyebrow" className="eyebrow mb-7 text-sable">
            {t.hero_sub}
          </p>
          <SearchBar variant="hero" />
        </div>
      </div>
    </section>
  );
}
